var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.btnClass},[_c('a',{attrs:{"href":"#"}},[_c('table',{staticStyle:{"text-align":"center","width":"100%"}},[_c('tr',{staticStyle:{"width":"100%","line-height":"20px"}},[_c('td',{staticStyle:{"vertical-align":"middle","font-size":"20px","line-height":"50px"}},[_vm._t("default")],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3feb8b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/topography/components/IconButton.vue
// module id = null
// module chunks = 